var kbmax = embed;